import { VotingStats, VoteOption } from '../../hooks/useVoting'
import ShareButton from './ShareButton'

interface ResultsDisplayProps {
  stats: VotingStats | null
  userVote?: VoteOption | null
}

export default function ResultsDisplay({ stats, userVote = null }: ResultsDisplayProps) {
  if (!stats || stats.totalVotes === BigInt(0)) {
    return (
      <div className="glass-card rounded-3xl p-4 mt-4 border border-white/10 relative overflow-hidden text-center">
        <h3 className="text-sm font-semibold mb-2 text-white/90">
          Today's BaseVibe
        </h3>
        <p className="text-xs text-gray-400">
          No votes yet today. Be the first!
        </p>
      </div>
    )
  }

  const positiveCount = Number(stats.positiveVotes)
  const negativeCount = Number(stats.negativeVotes)
  const total = Number(stats.totalVotes)

  const positivePercentage = total > 0 ? Math.round((positiveCount / total) * 100) : 0
  const negativePercentage = total > 0 ? Math.round((negativeCount / total) * 100) : 0

  // Determine overall sentiment
  let sentiment = 'Neutral'
  let sentimentEmoji = '😐'

  if (positivePercentage > 60) {
    sentiment = 'Bullish'
    sentimentEmoji = '📈'
  } else if (negativePercentage > 60) {
    sentiment = 'Bearish'
    sentimentEmoji = '📉'
  } else if (positivePercentage > negativePercentage) {
    sentiment = 'Slightly Bullish'
    sentimentEmoji = '📊'
  } else if (negativePercentage > positivePercentage) {
    sentiment = 'Slightly Bearish'
    sentimentEmoji = '📊'
  }

  return (
    <div className="glass-card rounded-3xl p-4 mt-4 relative overflow-hidden">
      <h3 className="text-sm font-semibold mb-3 text-center text-white/90">
        Today's BaseVibe
      </h3>

      {/* Overall Sentiment */}
      <div className="text-center mb-4">
        <div className="text-3xl mb-1 filter drop-shadow-lg">{sentimentEmoji}</div>
        <div className={`text-lg font-bold mb-0.5 ${sentiment === 'Bullish' ? 'text-emerald-400' : sentiment === 'Bearish' ? 'text-rose-400' : 'text-blue-400'}`}>
          {sentiment}
        </div>
        <div className="text-xs text-gray-400">
          Based on {total} vote{total !== 1 ? 's' : ''} today
        </div>
      </div>

      {/* Vote Breakdown */}
      <div className="space-y-3">
        {/* Positive Votes */}
        <div>
          <div className="flex justify-between items-center mb-1.5">
            <div className="flex items-center gap-1.5">
              <span className="text-base text-xs text-emerald-400 font-medium">Mooning 🚀</span>
            </div>
            <div className="text-xs font-bold text-white">
              {positivePercentage}%
            </div>
          </div>
          <div className="w-full bg-white/5 rounded-full h-2 overflow-hidden border border-white/5">
            <div
              className="bg-gradient-to-r from-emerald-500 to-teal-400 h-full rounded-full transition-all duration-1000 shadow-[0_0_10px_rgba(52,211,153,0.5)]"
              style={{ width: `${positivePercentage}%` }}
            />
          </div>
        </div>

        {/* Negative Votes */}
        <div>
          <div className="flex justify-between items-center mb-1.5">
            <div className="flex items-center gap-1.5">
              <span className="text-base text-xs text-rose-400 font-medium">Rekt 🥀</span>
            </div>
            <div className="text-xs font-bold text-white">
              {negativePercentage}%
            </div>
          </div>
          <div className="w-full bg-white/5 rounded-full h-2 overflow-hidden border border-white/5">
            <div
              className="bg-gradient-to-r from-rose-500 to-orange-400 h-full rounded-full transition-all duration-1000 shadow-[0_0_10px_rgba(251,113,133,0.5)]"
              style={{ width: `${negativePercentage}%` }}
            />
          </div>
        </div>
      </div>

      {/* Share Button */}
      <div className="mt-4 flex justify-center">
        <ShareButton stats={stats} userVote={userVote} />
      </div>
    </div>
  )
}



